<template>
    <views
        :class="{'white': whiteBg}"
        class="user">
        <views class="user-name" @click="handleBaseInfo">{{ userObj.real_name || userObj.nick_name }}</views>
        <views class="user-phone">
            <views class="icon">
                <images :src="phoneIcon"></images>
            </views>
            <views  class="title">
                <a :href="tel(userObj.mobile)">{{ userObj.mobile || "暂无" }}</a>
            </views>
        </views>
        <views class="user-menu">
            <views class="edit-info" @click="handleImproveInfo">
                <views class="edit-info-title">完善资料</views>
                <views class="edit-info-point">获积分</views>
                <views class="edit-info-icon">
                    <images :src="pointIcon"></images>
                </views>
            </views>
        </views>
        <views class="user-img" @click="handleBaseInfo">
            <images :src="userImg"></images>
        </views>
        <views class="user-level" @click="handleBaseInfo">
            <images :src="userLevel"></images>
        </views>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    props: {
        whiteBg: {
            type: Boolean,
            default: true
        },
        userObj: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            img: '',
            defaultImg: require('@/assets/images/user_img_default.png'),
            userLevel: require('@/assets/images/user_level.png'),
            pointIcon: require('@/assets/images/point_icon.png'),
            phoneIcon: require('@/assets/images/phone_icon.png')
        }
    },
    computed: {
        userImg() {
            return this.userObj.avatar ? this.userObj.avatar : this.defaultImg
        }
    },
    methods: {
        handleImproveInfo() {
            this.push('/improve-info')
        },
        handleBaseInfo() {
            this.push('/base-info')
        },
        tel(str) {
            return `tel:${str}`
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
